import { Action } from '@ngrx/store'

import { RequestWrap } from '../../core/models/request-wrap'
import { OrderHistory } from '../models/orderhistory'
import { OrderHistoryLine } from '../models/orderhistoryline';
import { Product } from '../../core/models/product'

export enum OrderHistoryActionTypes {
  LoadOrderHistory = '[OrderHistory] Load OrderHistory',
  LoadOrderHistorySuccess = '[OrderHistory] Load OrderHistory Success',
  LoadOrderHistoryFailed = '[OrderHistory] Load OrderHistory Failed',

  LoadOrderHistoryExpand = '[OrderHistory] Load OrderHistory Expand',
  LoadOrderHistoryExpandSuccess = '[OrderHistory] Load OrderHistory Expand Success',
  LoadOrderHistoryExpandFailed = '[OrderHistory] Load OrderHistory Expand Failed',

  LoadOrderHistoryLines = '[OrderHistory] Load OrderHistory Lines',
  LoadOrderHistoryLinesSuccess = '[OrderHistory] Load OrderHistory Lines Success',
  LoadOrderHistoryLinesFailed = '[OrderHistory] Load OrderHistory Lines Failed',

  LoadOrderHistoryLinesExpand = '[OrderHistory] Load OrderHistory Lines Expand',
  LoadOrderHistoryLinesExpandSuccess = '[OrderHistory] Load OrderHistory Lines Expand Success',
  LoadOrderHistoryLinesExpandFailed = '[OrderHistory] Load OrderHistory Lines Expand Failed',

  LoadOrderHistoryItem = '[OrderHistory] Load OrderHistory Item',
  LoadOrderHistoryItemSuccess = '[OrderHistory] Load OrderHistory Item Success',
  LoadOrderHistoryItemFailed = '[OrderHistory] Load OrderHistory Item Failed',

  ResetOrderHistory = '[OrderHistory] Reset',
  ResetOrderHistoryLines = '[OrderHistory] Reset Lines',

  LoadReOrderableItems = '[OrderHistory] Load ReOrderable Items',
  LoadReOrderableItemsSuccess = '[OrderHistory] Load ReOrderable Items Success',
  LoadReOrderableItemsFailed = '[OrderHistory] Load ReOrderable Items Failed',
}

export class LoadOrderHistory implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistory
}

export class LoadOrderHistorySuccess implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistorySuccess
  constructor (public payload: RequestWrap<OrderHistory[]>) { }
}

export class LoadOrderHistoryFailed implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryFailed
  constructor (public payload: any) { }
}

export class LoadOrderHistoryExpand implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryExpand
}

export class LoadOrderHistoryExpandSuccess implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryExpandSuccess
  constructor (public payload: RequestWrap<OrderHistory[]>) { }
}

export class LoadOrderHistoryExpandFailed implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryExpandFailed
  constructor (public payload: any) { }
}

export class LoadOrderHistoryLines implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryLines
}

export class LoadOrderHistoryLinesSuccess implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryLinesSuccess
  constructor (public payload: RequestWrap<OrderHistoryLine[]>) { }
}

export class LoadOrderHistoryLinesFailed implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryLinesFailed
  constructor (public payload: any) { }
}

export class LoadOrderHistoryLinesExpand implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryLinesExpand
}

export class LoadOrderHistoryLinesExpandSuccess implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryLinesExpandSuccess
  constructor (public payload: RequestWrap<OrderHistoryLine[]>) { }
}

export class LoadOrderHistoryItem implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryItem
}

export class LoadOrderHistoryItemSuccess implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryItemSuccess
  constructor (public payload: OrderHistory) { }
}

export class LoadOrderHistoryItemFailed implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryItemFailed
  constructor (public payload: any) { }
}

export class LoadOrderHistoryLinesExpandFailed implements Action {
  readonly type = OrderHistoryActionTypes.LoadOrderHistoryLinesExpandFailed
  constructor (public payload: any) { }
}

export class ResetOrderHistory implements Action {
  readonly type = OrderHistoryActionTypes.ResetOrderHistory
}

export class ResetOrderHistoryLines implements Action {
  readonly type = OrderHistoryActionTypes.ResetOrderHistoryLines
}

export class LoadReOrderableItems implements Action {
  readonly type = OrderHistoryActionTypes.LoadReOrderableItems
}
export class LoadReOrderableItemsSuccess implements Action {
  readonly type = OrderHistoryActionTypes.LoadReOrderableItemsSuccess
  constructor (public payload: RequestWrap<Product[]>) { }
}
export class LoadReOrderableItemsFailed implements Action {
  readonly type = OrderHistoryActionTypes.LoadReOrderableItemsFailed
  constructor (public payload: any) { }
}

export type OrderHistoryActions =
LoadOrderHistory
| LoadOrderHistorySuccess
| LoadOrderHistoryFailed
| LoadOrderHistoryExpand
| LoadOrderHistoryExpandSuccess
| LoadOrderHistoryExpandFailed
| LoadOrderHistoryLines
| LoadOrderHistoryLinesSuccess
| LoadOrderHistoryLinesFailed
| LoadOrderHistoryLinesExpand
| LoadOrderHistoryLinesExpandSuccess
| LoadOrderHistoryItem
| LoadOrderHistoryItemSuccess
| LoadOrderHistoryItemFailed
| LoadOrderHistoryLinesExpandFailed
| ResetOrderHistory
| ResetOrderHistoryLines
| LoadReOrderableItems
| LoadReOrderableItemsSuccess
| LoadReOrderableItemsFailed
